import store from "@/store";
import { ProfileService } from "../profile.service";

/**
 * type - 1: 判断该项目是否已有预算报价
 *        2: 判断该项目是否已有投标申请
 *        3：判断该项目是否已有投标报价
 *        4：判断该项目是否已有投标报名费
 *        5：判断该项目是否已有施工立项信息
 *        6：判断该项目是否已有施工预算信息
 *        7：判断该项目是否已有开工报告信息
 *        8：判断该项目是否已有施工计划
 *        9：判断该项目是否有产值结算管理信息
 *        10：判断该项目是否有竣工验收信息
 *        11：判断该项目是否有竣工决算信息
 *        12：判断该项目是否有开标管理信息
 */

export const tabListArr: any = [
  {
    key: "1",
    label: "项目信息",
    path: "/project/profile/detail",
    id:async (projectId) => {
        return projectId;
    }
  },
  {
    key: "2",
    label: "项目跟进",
    path: "/project/follow/list",
  },
  {
    key: "3",
    label: "勘察记录",
    path: "/project/reconnoiter/list",
  },
  {
    key: "4",
    label: "预算报价",
    path: "/project/solution/detail",
    id:async (projectId) => {
      let res= await ProfileService.useGetIdApi({projectId,type:[1]}); 
      if(res&&res.data?.data&&res.data?.data.relationList&&res.data?.data.relationList.length>0){
        return res.data?.data?.relationList[0]?.skipId || '';
      }else{
        return '';
      }  
     },
    addPath: "/project/solution/create",
  },
  {
    key: "5",
    label: "投标申请",
    path: "/tender/apply/detail",
    id:async (projectId) => {
      let res= await ProfileService.useGetIdApi({projectId,type:[2]});     
        if(res&&res.data?.data&&res.data?.data.relationList&&res.data?.data.relationList.length>0){
          return res.data?.data?.relationList[0]?.skipId || '';
        }else{
          return '';
        }
     },
    addPath: "/tender/apply/create",
  },
  {
    key: "6",
    label: "投标报价",
    path: "/tender/quote/detail",
    id:async (projectId) => {
      let res= await ProfileService.useGetIdApi({projectId,type:[3]});     
        if(res&&res.data?.data&&res.data?.data.relationList&&res.data?.data.relationList.length>0){
          return res.data?.data?.relationList[0]?.skipId || '';
        }else{
          return '';
        }
     },
    addPath: "/tender/quote/create",
  },
  {
    key: "7",
    label: "投标报名费",
    path: "/tender/material/detail",
    id:async (projectId) => {
      let res= await ProfileService.useGetIdApi({projectId,type:[4]});     
        if(res&&res.data?.data&&res.data?.data.relationList&&res.data?.data.relationList.length>0){
          return res.data?.data?.relationList[0]?.skipId || '';
        }else{
          return '';
        }
     },
    addPath: "/tender/material/create",
  },
  {
    key: "8",
    label: "投标文档管理",
    path: "/tender/doc/library",
  },
  {
    key: "9",
    label: "开标管理",
    path: "/tender/bid-manage/detail",
    id:async (projectId) => {
      let res= await ProfileService.useGetIdApi({projectId,type:[12]});     
        if(res&&res.data?.data&&res.data?.data.relationList&&res.data?.data.relationList.length>0){
          return res.data?.data?.relationList[0]?.skipId || '';
        }else{
          return '';
        }
     },
    addPath: "/tender/bid-manage/create",
  },
  {
    key: "10",
    label: "工程合同",
    path: "/contract/profile/list",
  },
  {
    key: "11",
    label: "合同变更",
    path: "/contract/change/list",
    addPath: "/contract/change/create",
  },
  {
    key: "12",
    label: "甲方签证",
    path: "/contract/visa/list",
    addPath: "/contract/visa/create",
  },
  {
    key: "13",
    label: "开票申请",
    path: "/contract/invoice/list",
    addPath: "/contract/invoice/create",
  },
  {
    key: "14",
    label: "保证金申请",
    path: "/tender/earnest-money/list",
  },
  {
    key: "15",
    label: "施工立项",
    path: "/work-manage/setup/detail",
    id:async (projectId) => {
      let res= await ProfileService.useGetIdApi({projectId,type:[5]});     
        if(res&&res.data?.data&&res.data?.data.relationList&&res.data?.data.relationList.length>0){
          return res.data?.data?.relationList[0]?.skipId || '';
        }else{
          return '';
        }
     },
    addPath: "/work-manage/setup/create",
  },
  {
    key: "16",
    label: "施工预算",
    path: "/work-manage/budget/detail",
    id:async (projectId) => {
      let res= await ProfileService.useGetIdApi({projectId,type:[6]});     
        if(res&&res.data?.data&&res.data?.data.relationList&&res.data?.data.relationList.length>0){
          return res.data?.data?.relationList[0]?.skipId || '';
        }else{
          return '';
        }
     },
    addPath: "/work-manage/budget/create",
  },
  {
    key: "17",
    label: "开工报告",
    path: "/work-manage/project-work/detail",
    id:async (projectId) => {
      let res= await ProfileService.useGetIdApi({projectId,type:[7]});     
        if(res&&res.data?.data&&res.data?.data.relationList&&res.data?.data.relationList.length>0){
          return res.data?.data?.relationList[0]?.skipId || '';
        }else{
          return '';
        }
     },
    addPath: "/work-manage/project-work/create",
  },
  {
    key: "18",
    label: "施工计划",
    path: "/work-manage/project-plan/detail",
    id:async (projectId) => {
      let res= await ProfileService.useGetIdApi({projectId,type:[8]});     
        if(res&&res.data?.data&&res.data?.data.relationList&&res.data?.data.relationList.length>0){
          return res.data?.data?.relationList[0]?.skipId || '';
        }else{
          return '';
        }
     },
    addPath: "/work-manage/project-plan/create",
  },
  {
    key: "19",
    label: "施工日志",
    path: "/work-manage/log/list",
  },
  {
    key: "20",
    label: "进度填报",
    path: "/work-manage/progress/list",
  },
  {
    key: "21",
    label: "项目交底",
    path: "/work-manage/present/list",
    addPath: "/work-manage/present/create",
  },
  {
    key: "22",
    label: "项目文档",
    path: "/work-manage/project-document/library",
  },
  {
    key: "23",
    label: "采购申请",
    path: "/purchase/apply/list",
    addPath: "/purchase/apply/create",
  },
  {
    key: "24",
    label: "零星采购",
    path: "/purchase/sporadicBuy/list",
    addPath: "/purchase/sporadicBuy/create",
  },
  {
    key: "25",
    label: "采购合同",
    path: "/purchase/contract/list",
    addPath: "/purchase/contract/create",
  },
  {
    key: "26",
    label: "采购合同变更",
    path: "/purchase/change/list",
    addPath: "/purchase/change/create",
  },
  {
    key: "27",
    label: "采购订单",
    path: "/purchase/order/list",
    addPath: "/purchase/order/create",
  },
  {
    key: "28",
    label: "采购合同结算记录",
    path: "/purchase/contractSettle/list",
    addPath: "/purchase/contractSettle/create",
  },
  {
    key: "29",
    label: "采购付款申请",
    path: "/purchase/payment/list",
    addPath: "/purchase/payment/create",
  },
  {
    key: "30",
    label: "项目材料清单",
    path: "/material/manage/project-material/list",
  },
  {
    key: "31",
    label: "入库单",
    path: "/material/warehouse/list",
    addPath: "/material/warehouse/create",
  },
  {
    key: "32",
    label: "出库单",
    path: "/material/exWarehouse/list",
    addPath: "/material/exWarehouse/create",
  },
  {
    key: "33",
    label: "订单入库申请",
    path: "/purchase/receive/list",
    addPath: "/purchase/receive/create",
  },
  {
    key: "34",
    label: "项目退料申请",
    path: "/material/materialReturn/list",
    addPath: "/material/materialReturn/create",
  },
  {
    key: "35",
    label: "自定义入库申请",
    path: "/material/otherWarehouse/list",
    addPath: "/material/otherWarehouse/create",
  },
  {
    key: "36",
    label: "项目领料申请",
    path: "/material/requisition/list",
    addPath: "/material/requisition/create",
  },
  {
    key: "37",
    label: "自定义出库申请",
    path: "/material/otherExWarehouse/list",
    addPath: "/material/otherExWarehouse/create",
  },
  {
    key: "38",
    label: "分包合同",
    path: "/subcontractManagement/profile/list",
    addPath: "/subcontractManagement/profile/create",
  },
  {
    key: "39",
    label: "分包结算",
    path: "/subcontractManagement/settlement/list",
    addPath: "/subcontractManagement/settlement/create",
  },
  {
    key: "40",
    label: "分包付款申请",
    path: "/subcontractManagement/payment/list",
    addPath: "/subcontractManagement/payment/create",
  },
  {
    key: "41",
    label: "租赁合同",
    path: "/lease-config/lease-contract/list",
    addPath: "/lease-config/lease-contract/create",
  },
  {
    key: "42",
    label: "租赁结算",
    path: "/lease-config/lease-settlement/list",
    addPath: "/lease-config/lease-settlement/create",
  },
  {
    key: "43",
    label: "租赁付款申请",
    path: "/lease-config/lease-payment-req/list",
    addPath: "/lease-config/lease-payment-req/create",
  },
  {
    key: "44",
    label: "巡检记录",
    path: "/inspection/records/list",
  },
  {
    key: "45",
    label: "质量检查",
    path: "/quality/check/list",
    addPath: "/quality/check/create",
  },
  {
    key: "46",
    label: "质量整改单",
    path: "/quality/change/list",
  },
  {
    key: "47",
    label: "质量整改验收",
    path: "/quality/receive/list",
  },
  {
    key: "48",
    label: "安全检查",
    path: "/safety/check/list",
    addPath: "/safety/check/create",
  },
  {
    key: "51",
    label: "安全整改单",
    path: "/safety/change/list",
  },
  {
    key: "52",
    label: "安全整改验收",
    path: "/safety/receive/list",
  },
  {
    key: "53",
    label: "开票管理",
    path: "/ticket/makeTicket/list",
  },
  {
    key: "54",
    label: "收票管理",
    path: "/ticket/incomeTicket/list",
  },
  {
    key: "55",
    label: "产值结算管理",
    path: "/projectPayment/contractSettlement/detail",
    id:async (projectId) => {
      let res= await ProfileService.useGetIdApi({projectId,type:[9]});     
        if(res&&res.data?.data&&res.data?.data.relationList&&res.data?.data.relationList.length>0){
          return res.data?.data?.relationList[0]?.skipId || '';
        }else{
          return '';
        }
     },
    addPath: "/projectPayment/contractSettlement/create",
  },
  {
    key: "56",
    label: "合同收款单",
    path: "/projectPayment/contractMoney/list",
  },
  {
    key: "57",
    label: "对外付款单",
    path: "/projectPayment/externalPayment/list",
  },
  {
    key: "58",
    label: "保证金支付",
    path: "/projectPayment/depositPayment/list",
  },
  {
    key: "59",
    label: "保证金退回",
    path: "/projectPayment/depositBack/list",
  },
  {
    key: "60",
    label: "费用报销",
    path: "/projectPayment/reimburse/list",
  },
  {
    key: "61",
    label: "竣工验收",
    path: "/finished-project/acceptance/detail",
    id:async (projectId) => {
      let res= await ProfileService.useGetIdApi({projectId,type:[10]});     
        if(res&&res.data?.data&&res.data?.data.relationList&&res.data?.data.relationList.length>0){
          return res.data?.data?.relationList[0]?.skipId || '';
        }else{
          return '';
        }
     },
    addPath: "/finished-project/acceptance/create",
  },
  {
    key: "62",
    label: "竣工决算",
    path: "/finished-project/approval-profits/detail",
    id:async (projectId) => {
      let res= await ProfileService.useGetIdApi({projectId,type:[11]});     
        if(res&&res.data?.data&&res.data?.data.relationList&&res.data?.data.relationList.length>0){
          return res.data?.data?.relationList[0]?.skipId || '';
        }else{
          return '';
        }
     },
    addPath: "/finished-project/approval-profits/create",
  },
  {
    key: "63",
    label: "审定利润",
    path: "/finished-project/final-accounts/list",
  }
 
];